import Header from "../../Common/Header";
import Register from "../../Components/Register";

const RegisterPage = () => {
  return (
    <>
      <div className="bg-primary max-md:h-auto h-screen text-white">
        <Header  />
        <Register/>
      </div>
    </>
  );
};

export default RegisterPage;
